<style lang="scss">
.tags {
    .tag,
    .expander {
        display: inline-block;
        padding: 8px 16px;
        color: theme('colors.green');
        letter-spacing: 0.34px;
        border-radius: 2px;
        background-color: theme('colors.green' / 10%);
        margin-right: 4px;
        transition: color 0.2s, background-color 0.2s;
        cursor: pointer;

        &:last-child {
            margin-right: 0;
        }

        &.active,
        &:hover {
            color: theme('colors.white');
            background-color: theme('colors.green');
        }
        &.hover-none {
            cursor: text;
            color: theme('colors.green');
            background-color: theme('colors.green' / 10%);
        }
    }
}
</style>

<template>
    <div class="blog-overview">
        <div class="secondary-filter md:text-center mb-10 md:mb-20">
            <div class="tags -mb-2">
                <template v-for="tag in tags">
                    <span v-if="tag" class="tag mb-2" :class="{ active: filter.tags.includes(tag.id) }" @click="() => toggleTag(tag.id)" :key="tag.id">{{ tag.name }}</span>
                </template>
            </div>
        </div>

        <div class="flex flex-wrap -m-5">
            <div v-for="blogpost in filteredPosts" :key="blogpost.id" class="w-full md:w-1/2 lg:w-1/3 xl:w-1/4 p-5 mb-10 md:mb-16 lg:mb-20">
                <blog-post :blog-post="blogpost" :translations="translations" :large="true"></blog-post>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        blogposts: {
            type: Array,
            required: true,
        },

        allTags: {
            type: Array,
            required: true,
        },

        translations: {
            type: Object,
            required: true,
        },
    },

    data: (vm) => ({
        filter: {
            tags: [],
        },
    }),

    mounted() {
        var self = this;
        const setFilterByParameter = () => {
            const params = new URLSearchParams(location.search);

            var tagStringArray = params.getAll('cat');

            for (var i = 0; i < tagStringArray.length; i++) {
                this.filter.tags.push(self.getTagBySlug(tagStringArray[i]).id);
            }
        };

        setFilterByParameter();
    },

    methods: {
        toggleTag(tagId) {
            const tags = this.filter.tags;
            const index = this.filter.tags.findIndex((t) => t === tagId);
            if (index >= 0) {
                tags.splice(index, 1);
            }
            if (index < 0) {
                tags.push(tagId);
            }
            this.filter.tags = tags.sort();

            this.populateSearchParams();
        },

        getTagById(id) {
            var match = this.allTags.filter((tag) => tag.id === id);
            if (match.length > 0) {
                return match[0];
            }
            return null;
        },

        getTagBySlug(slug) {
            var match = this.allTags.filter((tag) => tag.slug === slug);
            if (match.length > 0) {
                return match[0];
            }
            return null;
        },

        populateSearchParams() {
            var self = this;
            const params = new URLSearchParams();

            if (this.filter.tags !== null && this.filter.tags.length > 0) {
                this.filter.tags.forEach((tag) => {
                    params.append('cat', self.getTagById(tag).slug);
                });
            }

            let newUrl = location.pathname;
            if (params.toString()) {
                newUrl += `?${params}`;
            }

            window.history.replaceState({}, '', newUrl);
        },
    },

    computed: {
        tags() {
            var tags = [];

            for (var i = 0; i < this.blogposts.length; i++) {
                for (var j = 0; j < this.blogposts[i]['blog-category'].length; j++) {
                    if (tags.filter((t) => t != null && t.id === this.blogposts[i]['blog-category'][j]).length == 0) {
                        var actualTag = this.allTags.filter((t) => t != null && t.id === this.blogposts[i]['blog-category'][j])[0];
                        tags.push(actualTag);
                    }
                }
            }

            return tags;
        },

        filteredPosts() {
            if (this.filter.tags.length > 0) {
                return this.blogposts.filter((p) => p['blog-category'].some((id) => this.filter.tags.includes(id)));
            } else {
                return this.blogposts;
            }
        },
    },
};
</script>
